/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Cc_Mode_TitleInputs */

const en_styles_cc_mode_title = /** @type {(inputs: Styles_Cc_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed Captioning Mode`)
};

const fr_styles_cc_mode_title = /** @type {(inputs: Styles_Cc_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode sous-titrage`)
};

const de_styles_cc_mode_title = /** @type {(inputs: Styles_Cc_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitelmodus`)
};

const it_styles_cc_mode_title = /** @type {(inputs: Styles_Cc_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modalità sottotitoli`)
};

const ru_styles_cc_mode_title = /** @type {(inputs: Styles_Cc_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Режим субтитров`)
};

const es_styles_cc_mode_title = /** @type {(inputs: Styles_Cc_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo de subtítulos cerrados`)
};

const zh_cn2_styles_cc_mode_title = /** @type {(inputs: Styles_Cc_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐藏式字幕模式`)
};

const ja_styles_cc_mode_title = /** @type {(inputs: Styles_Cc_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クローズドキャプションモード`)
};

const hi_styles_cc_mode_title = /** @type {(inputs: Styles_Cc_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद कैप्शनिंग मोड`)
};

const pt_pt2_styles_cc_mode_title = /** @type {(inputs: Styles_Cc_Mode_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo de legenda oculta`)
};

/**
* | output |
* | --- |
* | "Closed Captioning Mode" |
*
* @param {Styles_Cc_Mode_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_cc_mode_title = /** @type {((inputs?: Styles_Cc_Mode_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Cc_Mode_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_cc_mode_title(inputs)
	if (locale === "de") return de_styles_cc_mode_title(inputs)
	if (locale === "it") return it_styles_cc_mode_title(inputs)
	if (locale === "ru") return ru_styles_cc_mode_title(inputs)
	if (locale === "es") return es_styles_cc_mode_title(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_cc_mode_title(inputs)
	if (locale === "ja") return ja_styles_cc_mode_title(inputs)
	if (locale === "hi") return hi_styles_cc_mode_title(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_cc_mode_title(inputs)
	return en_styles_cc_mode_title(inputs)
});